export default {"src":"/_next/static/media/diamond_ring_24.223916e5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};